import { Fragment } from 'react';

// MUI
import { FormControl } from '@mui/base';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import { Box, alpha } from '@mui/system';

interface BaseProps {
  label?: React.ReactNode;
  required?: boolean;
  invalid?: boolean;
  displayParts: string[];
}

const OperationCodeFieldBase: React.FC<BaseProps> = ({
  label,
  required = true,
  invalid = false,
  displayParts,
}) => {
  return (
    <FormControl error={invalid}>
      <InputLabel
        required={required}
        style={{
          height: 'auto',
          display: 'unset',
        }}
        error={invalid}
      >
        {label}
      </InputLabel>
      <Box
        sx={{
          display: 'flex',
          height: 40,
          borderColor: (theme) => alpha(theme.palette.text.primary, 0.23),
          overflow: 'hidden',
          width: '100%',
        }}
      >
        {displayParts.map((segment, index) => (
          <Fragment key={index}>
            <TextField
              value={segment}
              error={invalid}
              InputProps={{
                readOnly: true,
                style:
                  index === 0
                    ? {
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 0,
                        borderTopRightRadius: 0,
                      }
                    : index === displayParts.length - 1
                      ? {
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 8,
                          borderTopRightRadius: 8,
                        }
                      : { borderRadius: 0 },
                sx: {
                  height: '100%',
                  flex: 1,
                  overflow: 'hidden',
                },
              }}
              inputProps={{
                style: {
                  textAlign: 'center',
                },
              }}
              sx={{ flex: 1 }}
            />
            {index !== displayParts.length - 1 && (
              <Box
                sx={{
                  height: '100%',
                  borderTop: '1px solid',
                  borderBottom: '1px solid',
                  borderColor: (theme) =>
                    invalid ? theme.palette.error.main : alpha(theme.palette.text.primary, 0.23),
                  px: 0.5,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {'-'}
              </Box>
            )}
          </Fragment>
        ))}
      </Box>
    </FormControl>
  );
};

export default OperationCodeFieldBase;
